import { omit } from 'lodash'

import { newFileAudioClips } from '../store/newFileState'
import { audioClipId } from '../store/newIds'
import {
  ADD_AUDIO_CLIP_FROM_IDEA_BOARD,
  DELETE_AUDIO_CLIP,
  FILE_LOADED,
  NEW_FILE,
  LOAD_AUDIO_CLIPS,
  UNDO_N_TIMES,
  REDO_N_TIMES,
  UNDO,
  REDO,
} from '../constants/ActionTypes'

/**
 * @type {PlottrFileAudioClips}
 */
const DEFAULT_STATE = {}

/**
 * @typedef {import('../index').PlottrFileAudioClips} PlottrFileAudioClips
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @template T
 * @typedef {import('../types/reducer').DataRepairer<T>} DataRepairer
 */

/**
 * @param {DataRepairer<any>} _dataRepairers
 * @return {function(PlottrFileAudioClips, PltrAction): PlottrFileAudioClips}
 */
const audioClips = (_dataRepairers) => (state, action) => {
  switch (action.type) {
    case ADD_AUDIO_CLIP_FROM_IDEA_BOARD: {
      const newId = audioClipId(state)
      const newAudioClip = { ...action.audioClip, id: newId }
      return {
        ...state,
        [newId]: newAudioClip,
      }
    }

    case DELETE_AUDIO_CLIP: {
      if (state[action.id]) {
        return omit(state, action.id)
      } else {
        return state
      }
    }

    case FILE_LOADED: {
      return action.data.audioClips ?? DEFAULT_STATE
    }

    case NEW_FILE: {
      return newFileAudioClips
    }

    case LOAD_AUDIO_CLIPS: {
      return action.audioClips
    }

    case UNDO_N_TIMES:
    case REDO_N_TIMES:
    case UNDO:
    case REDO: {
      if (Array.isArray(action.state.audioClips)) {
        return action.state.audioClips
      } else {
        return state
      }
    }

    default: {
      return state ?? newFileAudioClips
    }
  }
}

export default audioClips
